import { useContext, useState } from "preact/hooks";
import { useMutation } from "@apollo/client";
import useLocalStorageState from "use-local-storage-state";
import LogRocket from 'logrocket';
import { GlobalContext } from "@/context/GlobalContext";
import { useToggleSideCart } from "@/hooks/toggleSideCart";
import ADD_TO_CART_MUTATION from "@/mutations/addToCart";
import useSnackBar from "@/hooks/useSnackBar";
import { formatter } from "@/Utils";
import { trackAddToCart } from "@/gtm-analytics";
import { surfsideTrackAddToCart } from "@/shared/surfside-analytics";

function useAddToCart() {
	const { handleOpen } = useSnackBar();
	const toggleSideCart = useToggleSideCart();
	const [status, setStatus] = useState('idle');
	const [addToCart, { loading, error }] = useMutation(ADD_TO_CART_MUTATION, {
		onCompleted(data) {
			setStatus('complete');
			toggleSideCart();
		},
		onError(error) {
			setStatus('idle');
			console.log(error);
			handleOpen(error.message);
			LogRocket.captureMessage(error);
		},
	});
	const [retailerObject, setRetailerObject] = useLocalStorageState("dutchie_retailer");
	const retailerSlug = retailerObject?.slug;
	const retailerId = retailerObject?.id;
	const [checkoutId, setCheckoutId] = useLocalStorageState("dutchie_checkout_" + retailerSlug);
	const [promoItems, setPromoItems] = useLocalStorageState("promo_items");
	const [promo, setPromo] = useLocalStorageState("cp_promo");

	const { checkout } = useContext(GlobalContext);

	const handleAddToCart = (event, product, quantity, weight) => {
		event.preventDefault();
		event.stopPropagation();
		setStatus('loading');

		addToCart({
			variables: {
				retailerId: retailerId,
				checkoutId: checkoutId,
				productId: product.id,
				quantity: quantity,
				option: weight ? weight.option : product.variants[0].option,
			}
		});

		const retailerName = retailerObject.name;
		let price, specialPrice;
		price = weight ? weight.priceRec : product.variants[0].priceRec; 
		specialPrice = weight ? weight.specialPriceRec : product.variants[0].specialPriceRec;

		let details = {
			product, 
			quantity, 
			price, 
			specialPrice, 
			weight,
			retailerName, 
			retailerId, 
			checkout 
		}

		trackAddToCart(details);

		if (typeof surf !== 'undefined') {
			surfsideTrackAddToCart(product, quantity, checkout.items.length);
		}
	};

	return {
		handleAddToCart,
		status
	}
}
export default useAddToCart;